import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { reset, change } from 'redux-form';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import Subheader from 'material-ui/Subheader';

import { SyncLoader } from 'halogenium';

import { getUnitTypes, getUnits, getProperties } from 'actions/landlordPropertiesActions';
import * as maintenanceReducer from 'actions/maintenanceActions';
import * as landlordShowings from 'actions/landlordShowingsActions';
import * as bookings from 'actions/bookingsActions';

import AssignToAgentForm from 'components/bookings/assign_to_agents_form';
import ShowingForm from 'components/bookings/showings_form';
import ShowingResults from 'components/bookings/bookingResults';
import SearchableSelect from 'components/shared/SearchableSelect';

import { daysFromNow } from 'helpers/Formatter';
import { colors } from 'helpers/ColorHelper';

const changeFieldValue = (field, value) => change('assign_agent', field, value);

export default withMobileDialog()(
  connect(
    store => {
      return {
        showEditShowingDialog: store.landlordShowings.showEditShowingDialog,
        showingDetails: store.landlordShowings.showingDetails,
        isLoading: store.bookings.isLoading,
        bookingErrorMessages: store.bookings.errorMessage,
        showSelectBooking: store.bookings.select_availability,
        timeAvailability: store.bookings.timeAvailability,
        agents: store.maintenanceReducer.agents,
        units: store.landlordProperties.units,
        properties: store.landlordProperties.properties,
      };
    },
    {
      ...maintenanceReducer,
      ...landlordShowings,
      ...bookings,
      getUnits,
      getUnitTypes,
      getProperties,
      reset,
      changeFieldValue,
    }
  )(
    class showingsNonGrid extends Component {
      state = { selectedPropertyMultiselect: this.props.showingDetails.property_for_multiselect };

      componentDidMount = () => {
        this.props.removePreviousSearchResults();
        this.props.resetBookingsState();
        this.props.getListOfAgents();
        this.props.getUnits(this.props.showingDetails.property_details.id, {
          for_multiselect: true,
        });
        this.props.getUnitTypes(this.props.showingDetails.property_details.id);
      };

      onPropertyChange = property => {
        this.props.changeFieldValue('unit', null);
        this.props.getUnits(property.value, { for_multiselect: true });
        this.props.getUnitTypes(property.value);
        this.setState({ selectedPropertyMultiselect: property });
      };

      submitBookingTimesForm = vars => {
        this.props.setToIsLoading();
        this.props.removePreviousSearchResults();
        this.props.getApartmentAvailability(
          this.state.selectedPropertyMultiselect.value,
          vars.time,
          vars.date,
          vars.unit_type
        );
      };

      updateBookingWithExtraData = async (bookTime, bookDate, unitType) => {
        await this.props.putShowing(this.props.showingDetails.id, {
          requested_time: bookTime,
          requested_date: bookDate,
          property_id: this.state.selectedPropertyMultiselect.value,
          unit_type: unitType,
        });
        this.props.removePreviousSearchResults();
        this.props.resetBookingsState();
        this.props.reset('book_showing');
        this.props.getShowingAndShowings();
      };

      assignToAgentForm = async formData => {
        await this.props.assignShowingToAgent(
          formData,
          this.props.showingDetails.id,
          this.state.selectedPropertyMultiselect.value
        );
        this.props.getShowingAndShowings();
      };

      reassignToAgentForm = async formData => {
        await this.props.putShowing(this.props.showingDetails.id, {
          agent_id: formData.assign.value,
        });
        this.props.getShowingAndShowings();
      };

      render() {
        return (
          <Fragment>
            {this._renderShowAssign()}
            {this._renderShowReAssign()}
            {this._renderModifyBooking(this.state.selectedPropertyMultiselect)}
          </Fragment>
        );
      }

      _renderShowAssign = () => {
        if (this.props.showAssign)
          return (
            <div className="row" style={{ padding: '15px 0' }}>
              <p style={{ padding: '0 25px' }}>
                Once a showing has been completed, make sure to assign the showing to the respective
                unit and agent below.
              </p>

              <div
                className="row"
                id="modify_showing"
                style={{
                  fontSize: '15px',
                  marginTop: '0px',
                  color: '#4e4e4e',
                }}
                ref="modify_showing"
              >
                <div
                  className="row"
                  style={{
                    maxWidth: '250px',
                    margin: 'auto',
                  }}
                >
                  <Subheader
                    inset={false}
                    style={{
                      lineHeight: 0,
                      padding: '20px 0px 15px 0px',
                    }}
                  >
                    Property
                  </Subheader>
                  <SearchableSelect
                    name="property"
                    placeholder="Property"
                    options={this.props.properties}
                    onChange={this.onPropertyChange}
                    fullWidth
                    floatingLabel="Property"
                    value={this.state.selectedPropertyMultiselect}
                  />
                </div>
                <AssignToAgentForm
                  formName="assign_agent"
                  onSubmit={this.assignToAgentForm}
                  buttonLabel="Modify"
                  property={this.state.selectedPropertyMultiselect}
                  units={this.props.units}
                  agents={this.props.agents}
                />
              </div>
            </div>
          );
      };

      _renderShowReAssign = () => {
        if (this.props.showReAssign) {
          return (
            <div className="row" style={{ padding: '15px 0' }}>
              <p style={{ padding: '0 25px' }}>
                If you would like to re-assign this showing to another agent, select their name
                below. Re-assignment will not take the agents availability settings in account, and
                should only be done with their approval.
              </p>
              <div
                className="row"
                id="modify_showing"
                style={{
                  fontSize: '15px',
                  marginTop: '0px',
                  color: '#4e4e4e',
                }}
                ref="modify_showing"
              >
                <AssignToAgentForm
                  formName="reassign_agent"
                  onSubmit={this.reassignToAgentForm}
                  buttonLabel="Modify"
                  agents={this.props.agents}
                />
              </div>
            </div>
          );
        }
      };

      _renderModifyBooking = selectedProperty => {
        if (this.props.showModify)
          return (
            <div className="row" style={{ padding: '15px 0' }}>
              <div
                className="row"
                id="modify_showing"
                style={{
                  fontSize: '15px',
                  marginTop: '0px',
                  color: '#4e4e4e',
                }}
                ref="modify_showing"
              >
                <div
                  className="row"
                  style={{
                    width: '250px',
                    margin: 'auto',
                    padding: '0 15px',
                  }}
                >
                  <label
                    style={{
                      transform: 'scale(0.75) translateY(15px)',
                      transformOrigin: 'left top 0px',
                      color: colors.LABEL_GRAY,
                      float: 'left',
                    }}
                  >
                    Property
                  </label>
                  <SearchableSelect
                    name="property"
                    placeholder="Property"
                    options={this.props.properties}
                    onChange={this.onPropertyChange}
                    fullWidth
                    floatingLabel="Property"
                    value={selectedProperty}
                  />
                </div>
                <ShowingForm
                  onSubmit={this.submitBookingTimesForm}
                  buttonLabel="Modify"
                  maxDate={daysFromNow(30)}
                />
                <div
                  className="row"
                  style={{
                    textAlign: 'center',
                    fontSize: '12px',
                    marginTop: '5px',
                  }}
                />
              </div>

              {this._renderIsLoading()}
              {this._renderBookingErrorMessage()}
              {this._renderSelectBooking()}
            </div>
          );
      };

      _renderIsLoading = () => {
        if (!this.props.isLoading) return;

        return (
          <div>
            <p style={{ textAlign: 'center', marginTop: '30px' }}>
              <SyncLoader color="#ff5656" size="16px" margin="4px" />
            </p>
            <p style={{ textAlign: 'center', fontSize: '12px' }} id="loader">
              Hang tight! We&rsquo;re confirming availability.
            </p>
          </div>
        );
      };

      _renderBookingErrorMessage = () => {
        if (!this.props.bookingErrorMessages) return;

        return (
          <h6 style={{ textAlign: 'center', marginTop: '30px' }}>
            {this.props.bookingErrorMessages}
          </h6>
        );
      };

      _renderSelectBooking = () => {
        if (!this.props.showSelectBooking) return;

        return (
          <div className="row">
            <div
              id="modify_showing"
              style={{
                fontSize: '15px',
                marginTop: '10px',
                color: '#4e4e4e',
                width: '70%',
                margin: '0 auto',
              }}
              ref="modify_showing"
            >
              <ShowingResults
                isLucky={this.props.timeAvailability.lucky}
                timeAvailability={this.props.timeAvailability.availabilities}
                bookingId={1}
                dialogIsClosed={() => this.props.showNewShowingDialog}
                createCallCenterBooking={this.updateBookingWithExtraData}
              />
            </div>
          </div>
        );
      };
    }
  )
);
